export function unique<T>(value: T, index: number, self: Array<T>) {
  return self.indexOf(value) === index;
}
